module.exports = __webpack_public_path__ + "img/home-icon-4-4.8309d046.png";